import { ReportParams } from '../types';

/**
 * 触发埋点
 * @param {*} params
 */
function log(reportParams: ReportParams) {
    const HMAPP = (<any>window).HMAPP;
    if (!HMAPP) {
        throw new Error('SDK没有加载！');
    }
    const { eventId, pageType, actionType, extJson = {} } = reportParams;

    HMAPP.invoke('report_trace', {
        eventId,
        pageType, // 拓展参数，可能为空
        actionType, // 拓展参数，可能为空
        kvs: extJson // 拓展参数，可能为空
    });
}

export default log;
